<script>
  export let displayTimeString;
  export let starttimeMinutes;
  export let durationMinutes;

  const offsetMinutes = starttimeMinutes - 8 * 60;
  const timeblockStyle = `position: absolute; top: ${offsetMinutes * 3}px; height: ${durationMinutes * 3}px;`;
</script>

<div class="not-prose right-[2%] w-[46%] flex flex-col gap-1 border border-solid rounded-md border-gray-400/50 bg-im-brown-100 p-3 drop-shadow-md" style={timeblockStyle}>
  <span class="text-sm font-bold text-gray-700">Mittagspause</span>
  <span class="text-xs">{displayTimeString}</span>
  <span class="text-xs">Gesetztes Mittagessen</span>
</div>